import { DecayPeriod } from "./decay";
import { SandboxEntity, SandboxEntityType } from "./entities";
import { Interaction, InteractionType } from "./interactions";

interface InteractionBuilderState {
  _entityType: SandboxEntityType;
  _selectedEntity?: SandboxEntity;
  _interactionType: InteractionType;
  _selectedPeriod?: DecayPeriod;
  interactions: Interaction[];
}

interface SetEntityTypeAction {
  type: "set_entity_type";
  payload: SandboxEntityType;
}

interface SetSelectedEntityAction {
  type: "set_selected_entity";
  payload: SandboxEntity | undefined;
}

interface SetInteractionTypeAction {
  type: "set_interaction_type";
  payload: InteractionType;
}

interface SetSelectedPeriodAction {
  type: "set_selected_period";
  payload: DecayPeriod;
}

interface AddInteractionAction {
  type: "add_interaction";
  payload: { id: string };
}

interface RemoveInteractionAction {
  type: "remove_interaction";
  payload: string;
}

interface SetEntityEmbeddingAction {
  type: "set_entity_embedding";
  payload: {
    interactionId: string;
    embedding: number[] | null;
    error?: string;
    details?: string;
    name?: string;
  };
}

interface ResetInteractionsAction {
  type: "reset_interactions";
  payload: Interaction[];
}

type InteractionBuilderAction =
  | SetEntityTypeAction
  | SetSelectedEntityAction
  | SetInteractionTypeAction
  | SetSelectedPeriodAction
  | AddInteractionAction
  | RemoveInteractionAction
  | SetEntityEmbeddingAction
  | ResetInteractionsAction;

const INTERACTION_BUILDER_ACTION_TYPES = {
  SET_ENTITY_TYPE: "set_entity_type",
  SET_SELECTED_ENTITY: "set_selected_entity",
  SET_INTERACTION_TYPE: "set_interaction_type",
  SET_SELECTED_PERIOD: "set_selected_period",
  ADD_INTERACTION: "add_interaction",
  REMOVE_INTERACTION: "remove_interaction",
  SET_ENTITY_EMBEDDING: "set_entity_embedding",
  RESET_INTERACTIONS: "reset_interactions",
} as const;

export type { InteractionBuilderState, InteractionBuilderAction };
export { INTERACTION_BUILDER_ACTION_TYPES };
